export default {
    login: {
        title: 'Yuvarlak Örgü Makinesi Ayar Sayfası',
        menuTitle: 'Yuvarlak Örgü Makinesi Ayar Sayfası',
        logIn: 'Kayıt olmak',
        username: 'kullanıcı adı',
        userHint: 'Lütfen kullanıcı adınızı girin!',
        userInput: 'Lütfen girin!',
        password: 'şifre',
        passwordHint: 'Lütfen şifreyi girin!',
        passwordHint2: 'Harfler + Sayılar + Özel semboller en az 8 bit uzunluğunda!',
        passwordHint3: 'Lütfen şifreyi tekrar girin!',
        passwordHint4: 'Harfler + Sayılar + Özel semboller en az 8 bit uzunluğunda!',
        passwordHint5: 'İki şifre eşleşmiyor',
        loginHint: 'Hesabınız yok mu? Hemen kayıt olun',
        loginSuccess: 'Giriş başarılı!',
        registerTitle: 'Kayıt',
        passwordYes: 'Şifreyi doğrula',
        registerHint: 'Mevcut bir hesap ile giriş yap',
        registerSuccess: 'Kayıt başarılı!',
        userInfo: 'Kişisel bilgiler',
        logOut: 'Oturum Açma'
    },
    router: {
        home: 'Ana Sayfa',
        defectRecord: 'Hata Kaydetme',
        machine: 'Makine Ayarları',
        user: 'Personel Bilgileri',
        userSetting: 'Operatör Ayarları',
        export: 'Transfer Yönetimi',
        cleanData: 'Veri Temizliği',
    },
    home: {
        pleaseChoose: 'Lütfen seçin',
        equipment: 'Ekipman',
        refresh: 'Yenile',
        today: 'Bugün',
        week: 'Bu Hafta',
        moth: 'Bu Ay',
        defectAlarm: 'Hata Alarmı',
        defectCurve: 'Hata Eğrisi',
        defectType: 'Hata Türü',
        defectNumber: 'Hata Sayısı',
        defectCountUnit: '',
        haltCount: 'Aşağı zaman sayısı',
        last7day: 'Son 7 Gün',
        eqOverview: 'Aygıt Verisine Genel Bakış',
        eqDowntime: 'Cihazların kapanma süresi',
        updateData: 'Verileri güncelle',
        defectPercentage: 'Hata oranı',
        flaw: 'kusur',
        monday: 'Pazartesi günü',
        tuesday: 'Salı günü',
        wednesday: ' Çarşamba',
        thursday: 'Perşembe günü',
        friday: 'Cuma günü',
        saturday: 'Cumartesi günü',
        sunday: 'günü',
        next: 'Sonraki',
        deviceInfo: 'Aygıt Bilgisi',
        rpm: 'Dönme Hızı',
        defectShutdown: 'Hata kapanması',
        mean: 'Ortalama',
        generalShutdown: "Normal kapatma",
        totalDefects: 'Eksiklik sayısı',
        nonstopDefect: 'Durdurma Eksikliği',
        shutdownDefect: 'arıza arıza sorunu',
        downtimeDuration: 'Süre süresi',
        runningTime: 'çalışma süresi',
        hour: "saat",
    },
    defectRecord: {
        project: 'Sahip Olunan Proje',
        snCode: 'SN Kodu',
        deviceName: 'Aygıt Adı',
        data: 'Tarih',
        defectCause: 'Hata Nedeni',
        inquire: 'Sorgu',
        reset: 'Reset',
        derive: 'Gönder',
        deviceSnCode: 'Aygıt SN Kodu',
        cameraNumber: 'Kamera Sayısı',
        proNumber: 'Ürün No',
        operatorId: 'Operatör No',
        writeTime: 'Kayıt Süresi',
        row: 'İşlem',
        success: 'İstek başarılı!',
        total: 'Toplam',
        strip: 'Hata',
        viewsImg: 'Görüntül',
        noImg: 'Resim yok',
        closeImg: 'Kapat.',
        views: 'Görüntül',
        pageTheWarning: 'Bu bir ilk!',
        pageNextWarning: 'Bu sonuncusu!',
        importExcel: "Excel'e Dışa Aktar",
        stopStatus: 'Durdurma Durumu',
        noStop: 'Durmasın',
        yesStop: 'Dursun',
    },
    machine: {
        address: 'Adres',
        machineNo: 'Makine No',
        revolution: 'Dönme Hızı',
        signalStrength: 'Sinyal Gücü',
        noMachineInfo: 'Makine bilgisi yok'
    },
    account: {
        basicSetup: 'Temel Ayarlar',
        changePassword: 'Şifre Değiştirme',
        nickName: 'Lakap',
        gender: 'Cinsiyet',
        mal: 'Erkek',
        female: 'Kadın',
        mobile: 'Tel. No.',
        mailBox: 'Mail Adresi',
        address: 'Adres',
        updateBasic: 'Temel Bilgileri Güncelle',
        avatar: 'Resim',
        changeAvatar: 'Resmi Değiştir',
        success: 'Değişim başarılı!',
        warning: 'Resim boyutu sınırı 1MB!',
        rawPassword: 'Eski Şifre',
        newPassword: 'Yeni Şifre',
        affirmPassword: 'Yeni Şifre Tekrar',
        confirmChange: 'Değişikliği Onayla',
        hint: 'İpucu',
        status: 'Durum',
        deletedText: 'Silme başarılı!',
        inExport: 'Transfer',
        offStocks: 'Tamamlandı',
        defeated: 'Başarısız',
        sum: 'Toplam',
        startTime: 'Başlama Zamanı',
        endTime: 'Bitiş Zamanı',
        download: 'İndirme',
        delete: 'Sil',
        exporting: 'Transfer',
    }
}